export const PILL_SCROLL_TOLERANCE = 2;

export function clampPillScrollPosition(scrollPosition, layoutWidth, contentWidth) {
  const maxScrollPosition = Math.max(0, Number(contentWidth || 0) - Number(layoutWidth || 0));
  return Math.min(Math.max(0, Number(scrollPosition || 0)), maxScrollPosition);
}

export function getPillScrollState({
  scrollPosition,
  layoutWidth,
  contentWidth,
  hideArrows = false,
  tolerance = PILL_SCROLL_TOLERANCE,
}) {
  const maxScrollPosition = Math.max(0, Number(contentWidth || 0) - Number(layoutWidth || 0));
  const clampedPosition = clampPillScrollPosition(scrollPosition, layoutWidth, contentWidth);
  const hasOverflow = maxScrollPosition > tolerance;

  return {
    maxScrollPosition,
    clampedPosition,
    hasOverflow,
    showLeftArrow: !hideArrows && hasOverflow && clampedPosition > tolerance,
    showRightArrow: !hideArrows && hasOverflow && maxScrollPosition - clampedPosition > tolerance,
  };
}
